module.exports = __webpack_public_path__ + "static/media/hellboy-hited.38cd0a91.png";